module.exports = __webpack_public_path__ + "img/198.9c7930ed.jpg";